<template>
  <section class="calculator-picker-section">
    <div class="container">
      <div class="row">
        <div class="col col-12">
          <ToggleButton
            class="toggle-button"
            legent="Choose between calculators or tables"
            default-value="calculators"
            :initial-width="146"
            :options="[{ label: 'Calculators', value: 'calculators' }, { label: 'Tables', value: 'tables' }]"
            @change="(type) => updateType(type)"
          />
          <CalculatorSection v-if="activeType === 'calculators'" />
          <TableSection v-if="activeType === 'tables'" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ToggleButton from '@itbpbg/lms-components/src/components/ToggleButton';
import CalculatorSection from './CalculatorSection';
import TableSection from './TableSection';

export default {
  components: {
    ToggleButton,
    CalculatorSection,
    TableSection,
  },
  data() {
    return {
      activeType: 'calculators',
    };
  },
  methods: {
    updateType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style scoped lang="scss">
.calculator-picker-section {
  margin-top: 40px;
  padding-bottom: 60px;

  .toggle-button {
    margin-bottom: 40px;

    ::v-deep .toggle-container {
      max-width: 316px;
      width: 100%;

      .toggle-btn {
        font-family: "Mazzard", sans-serif;
      }
    }
  }
}

@include bp($bp-mobile) {
  .calculator-picker-section {
    padding-bottom: 40px;
  }
}
</style>
